
import { defineComponent, PropType, computed } from "vue";
import { DashboardBucket, externalLink } from "./trf";

export default defineComponent({
  name: "TopList",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "bi-list" },
    color: { type: String, default: "primary" },
    field: { type: String, required: true },
    buckets: { type: Array as PropType<DashboardBucket[]>, default: () => [] },
  },
  emits: ["filter"],
  setup(props) {
    // The API does not guarantee order — sort by count, highest first.
    const sortedBuckets = computed(() =>
      [...props.buckets].sort((a, b) => b.count - a.count)
    );
    const max = computed(() =>
      props.buckets.reduce((m, b) => Math.max(m, b.count), 0) || 1
    );
    const pct = (count: number) => Math.round((count / max.value) * 100);
    const external = (value: string) => externalLink(props.field, value);
    return { sortedBuckets, pct, external };
  },
});
